import gql from 'graphql-tag';

export default gql`
    query GetFilteredYards($input: String) {
        getFilteredYards(input: $input) {
            yardName
            id
            longitude
            latitude
            yardType
            yardTypeId
            addressStreet
            city
            zip
            phoneNumber
            description
            stateId
            utm
            directions
            geoFenceType
            geoFenceRadius
            yardPolygonCoordinates {
                lat
                lng
            }
            regionId
            districtId
        }
    }
`;
